import { Space } from '@looker/components';
import { BIIconButton, type IncludeExcludeState } from '@pulsepointinc/bi-components';
import { type FC, useCallback, useMemo } from 'react';

export const BulkUpdateSection: FC<{
  filterState: IncludeExcludeState;
  categories: string[];
  mode?: 'check' | 'block';
  handleFilterChange?: (state: IncludeExcludeState) => void;
}> = ({ mode, filterState, categories, handleFilterChange }) => {
  const categoriesBulkUpdate = useCallback(
    (categoriesToBlock: string[], action: 'check' | 'block') => {
      const areAlreadySelected = categoriesToBlock.every((category) => filterState[category]?.[action]);

      const blockedSubset = categoriesToBlock.reduce((obj, category) => {
        obj[category] = { block: false, check: false };
        obj[category][action] = !areAlreadySelected;

        return obj;
      }, {} as IncludeExcludeState);

      handleFilterChange?.({
        ...filterState,
        ...blockedSubset,
      });
    },
    [filterState, handleFilterChange],
  );

  const allChecked = useMemo(
    () => categories.length > 0 && categories.every((cat) => filterState[cat]?.check),
    [categories, filterState],
  );

  const allBlocked = useMemo(
    () => categories.length > 0 && categories.every((cat) => filterState[cat]?.block),
    [categories, filterState],
  );

  return (
    <Space>
      <BIIconButton
        icon="SelectAll"
        onClick={() => categoriesBulkUpdate(categories, 'check')}
        disabled={mode === 'block'}
        label={allChecked ? 'Unselect All' : 'Select All'}
      />
      <BIIconButton
        icon="BlockAll"
        label={allBlocked ? 'Unblock All' : 'Block All'}
        disabled={mode === 'check'}
        onClick={() => categoriesBulkUpdate(categories, 'block')}
      />
    </Space>
  );
};
